import { OrderContact } from "../api/ApiTypes.ts";
import {User, Contact} from "lucide-react";

export const OtherContactDisplay = ({ contact }: { contact: OrderContact }) => {
    if (!contact) return null;

    const formatContactType = (contact: OrderContact) => {
        return contact.type
            ? contact.type
                .split('_')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ')
            : 'Unknown Type';
    };

    return (
        <div className="mb-2 p-4 bg-white rounded-lg border border-slate-200 shadow-sm">
            <div className="flex items-start">
                <div className="flex-grow">
                    <h3 className="font-medium text-slate-900 flex items-center text-base">
                        <User className="h-5 w-5 mr-2 text-blue-500 flex-shrink-0" />
                        {contact.name || "Unnamed Contact"}
                    </h3>
                    <div className="flex items-center text-slate-500 text-xs mt-1">
                        <span className="pl-7 flex items-center">
                            <Contact className="h-3 w-3 mr-1 text-slate-400" />
                            {formatContactType(contact)}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};